/**
 * Empty-state titles. Only the title speaks — the hint under it stays the
 * neutral, actionable one at every call site, same rule as `empty_today`/
 * `empty_trends` already followed. Bucketed by `ctx.surface` since none of
 * these have a numeric context to key off.
 */

import type { SassContext } from '@gramas/shared'

type Line = (ctx: SassContext) => string

export const EMPTY: Readonly<Record<string, ReadonlyArray<Line>>> = {
  'empty_list.search': [
    () => 'Nieko. Visiška tyla kataloge.',
    () => 'Paieška grįžo tuščiomis.',
    () => 'Čia nieko nėra. Bent jau dar.',
    () => 'To kataloge nėra. Arba dar neišrasta.',
  ],
  'empty_list.favourites': [
    () => 'Mėgstamiausių sąrašas kaip tuščias muziejus.',
    () => 'Nieko pažymėta žvaigždute. Dar.',
    () => 'Favoritų nėra. Skonis dar neapsisprendė.',
    () => 'Tuščia. Lojalumas dar neuždirbtas.',
  ],
  'empty_list.recipes': [
    () => 'Receptų nėra. Virtuvė kol kas anoniminė.',
    () => 'Nė vieno recepto. Improvizacija irgi metodas.',
    () => 'Tuščia knyga. Pirmas receptas visada sunkiausias.',
    () => 'Receptų sąrašas tuščias kaip šaldytuvas prieš parduotuvę.',
  ],
  'empty_list.fastfood': [
    () => 'Duomenų nėra. Tinklas dar nesurinktas.',
    () => 'Meniu tuščias. Serveris dar renkasi mintis.',
    () => 'Čia dar nieko. Užsuk po atnaujinimo.',
    () => 'Tuščia. Greitas maistas, lėtai renkamas.',
  ],
  'empty_list.quickadd': [
    () => 'Dar nieko įrašyta. Istorija prasideda dabar.',
    () => 'Tuščia. Įprotis dar neįgytas.',
    () => 'Nieko. Rutina dar neatrasta.',
    () => 'Sąrašas tuščias. Kaip ir kiekvienas naujas įprotis.',
  ],
  'empty_list.photo': [
    () => 'Maisto neatpažinau. Kamera irgi turi blogų dienų.',
    () => 'Nieko neatpažinau. Nuotrauka meniu nepaaiškino.',
    () => 'Vaizdas nutylėjo, kas ant lėkštės.',
    () => 'Šiame kadre nieko valgomo neradau.',
  ],
}

export const EMPTY_META: Readonly<Record<string, number>> = {
  'empty_list.search': 2,
  'empty_list.favourites': 2,
  'empty_list.recipes': 2,
  'empty_list.fastfood': 2,
  'empty_list.quickadd': 2,
  'empty_list.photo': 2,
}
